/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { AlarmsAdvancedSettingsStore } from '../alarms-advanced-settings-store';

export const AdvancedSettingsStoreContext = createContext<AlarmsAdvancedSettingsStore>({} as AlarmsAdvancedSettingsStore);
